// extracted by mini-css-extract-plugin
module.exports = {"light":"cD_c","dark":"cD_b","headerSection":"cD_2","bgImage":"cD_jx"};